import {DistrictResource} from 'app/components/tv/apiResources/DistrictResource';
import {ImageInterface} from 'app/types/ImageInterface';
import CompetitionResource from 'app/components/tv/apiResources/CompetitionResource';
import CompetitionCategory from 'app/models/competition/CompetitionCategory';

export default class Competition {
  id: number;
  competitionSeasonId: number;
  slug: string;
  season: {
    slug: string;
    name: string;
  };
  name: string;
  middleName: string;
  shortName: string;
  active: boolean;
  ageGroup: {
    slug: string;
    name: string;
  };
  image: ImageInterface;
  district: DistrictResource;
  category: CompetitionCategory;
  level: number;
  order: number;
  videoAllowed: boolean;
  standingFormUpdatedAt: number;

  constructor(data: CompetitionResource) {
    Object.assign(this, data);
    this.category = new CompetitionCategory(data.category);
  }

  getName(): string {
    return this.name + (!this.active && this.season.name ? ` ${this.season.name}` : '');
  }
}
